const t = (b, y, K, e) => {
  const u = {
    stripeAccountId: void 0,
    mercadoPublicKey: null,
    xenditPublicKey: null
  }, l = (c) => b((d) => ({ ...d, publicKeys: { ...d.publicKeys, ...c } }));
  return {
    stripeAccountId: (e == null ? void 0 : e.stripeAccountId) ?? u.stripeAccountId,
    mercadoPublicKey: (e == null ? void 0 : e.mercadoPublicKey) ?? u.mercadoPublicKey,
    xenditPublicKey: (e == null ? void 0 : e.xenditPublicKey) ?? u.xenditPublicKey,
    setStripeAccountId: (c) => l({ stripeAccountId: c }),
    setMercadoPublicKey: (c) => l({ mercadoPublicKey: c }),
    setXenditPublicKey: (c) => l({ xenditPublicKey: c })
  };
};
export {
  t as createPublicKeysSlice
};
